import { render, staticRenderFns } from "./MovePanel.vue?vue&type=template&id=3576047c&scoped=true"
import script from "./MovePanel.vue?vue&type=script&lang=js"
export * from "./MovePanel.vue?vue&type=script&lang=js"
import style0 from "./MovePanel.vue?vue&type=style&index=0&id=3576047c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576047c",
  null
  
)

export default component.exports